import { Button } from "primereact/button";

import { Dialog, Icon } from "@/ds";

import styles from "./confirmacao-dialog.module.scss";
import type {
  ConfirmacaoDialogProps,
  ConfirmacaoDialogViewModel,
} from "./types-confirmacao-dialog";

/**
 * Confirmação do wizard no padrão do Figma `5333:105060` ("Rascunho GMUD"): header de 44 com borda, pergunta em
 * Condensed SemiBold 24, contexto Regular 16 e rodapé com borda. `Dialog` do DS (X e padrões do Figma): o `ConfirmDialog` do DS
 * segue o frame do componente (416, título no header) e não chega a este padrão.
 */
export function ConfirmacaoDialogView({
  visible,
  header,
  acceptLabel,
  rejectLabel,
  onHide,
  pergunta,
  contexto,
  confirmar,
  dialogTestId,
  cancelarTestId,
  confirmarTestId,
}: ConfirmacaoDialogProps & ConfirmacaoDialogViewModel) {
  return (
    <Dialog
      visible={visible}
      header={
        <span className={styles.headerTitle}>
          {/* Figma `5333:105061`: chevron "‹" (angle-left 14 num botão de 24) à frente do rótulo; aqui só decorativo. */}
          <span className={styles.headerIcon} aria-hidden>
            <Icon name="angle-left" size={14} />
          </span>
          {header}
        </span>
      }
      onHide={onHide}
      className={styles.dialog}
      headerClassName={styles.header}
      contentClassName={styles.content}
      data-testid={dialogTestId}
    >
      <div className={styles.body}>
        <p className={styles.pergunta}>{pergunta}</p>
        {contexto && <p className={styles.contexto}>{contexto}</p>}
      </div>
      <div className={styles.footer}>
        <Button
          type="button"
          label={rejectLabel}
          severity="secondary"
          onClick={onHide}
          data-testid={cancelarTestId}
        />
        <Button
          type="button"
          label={acceptLabel}
          onClick={confirmar}
          data-testid={confirmarTestId}
        />
      </div>
    </Dialog>
  );
}
